module.exports = __webpack_public_path__ + "media/images/brands/marque-revlonissimo@2x-cbef4cf760171c591ce81c01fdb3e04a.jpg";